<script setup lang="ts">
import { RouterView } from 'vue-router';
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import GlobalToasts from '@/components/common/GlobalToasts.vue';
</script>

<template>
  <RouterView />
  <ConfirmDialog />
  <GlobalToasts />
</template>
